/* Announcement Bar — Rotating messages */
(function() {
  'use strict';

  var bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  var messages = bar.querySelectorAll('.announcement-bar__message');
  if (messages.length < 2) return;

  var prevBtn = bar.querySelector('.announcement-bar__arrow--prev');
  var nextBtn = bar.querySelector('.announcement-bar__arrow--next');
  var speed = parseInt(bar.dataset.rotationSpeed || '4', 10) * 1000;
  var current = 0;
  var timer;

  function show(index) {
    messages[current].classList.remove('is-active');
    current = ((index % messages.length) + messages.length) % messages.length;
    messages[current].classList.add('is-active');
  }

  function next() { show(current + 1); }
  function prev() { show(current - 1); }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(next, speed || 4000);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { next(); startTimer(); });

  startTimer();
})();
